<template>
<div class="problemBox">
  <el-button type="text" @click="opendialogTableVisible" class="el-icon-question
"></el-button>
<el-dialog title="常见问题" :visible.sync="dialogTableVisible" :append-to-body="true">
  <el-table
      :data="problemList"
      style="width: 100%"
      @row-click="previewPdf">
      <el-table-column
        prop="helpFileName"
        label="文件名称"
        width="250">
      </el-table-column>
      <el-table-column
        prop="helpDesc"
        label="文件描述">
      </el-table-column>
    </el-table>
  <el-pagination
    layout="prev, pager, next"
    @current-change="handleSizeChange"
    :page-size="rows"
    :total="total">
  </el-pagination>
</el-dialog>
</div>
  
</template>
<script>
import $ from 'jquery'
export default {
  props:[],
  data(){
    return{
        dialogTableVisible: false,
        problemList:[],
        total:1,
        embedHhtml:'',
        rows:8,
        page:1
    }
  },
  created(){


  },
  methods:{
      opendialogTableVisible(){
          this.dialogTableVisible =true;
              this.getPageJson()
      },
    previewPdf(row){
      var pdfSrc = this.$http.getSignUrl('/api/previewPdf', {
          fileName: row.helpFilePath,
          token: this.$store.state.token
      })
      window.open(pdfSrc)
    },
    handleSizeChange(page){
      this.page = page
      this.getPageJson()
    },
    getPageJson(page){
      this.$http.postQuery("/api/help/pageJson ", {
        rows: this.rows,
        page: this.page
      },(res) => {
       this.problemList = res.data.rows;
       this.total = res.data.total
      });
    }
  }

}
</script>
<style rel="stylesheet/scss" lang="scss" >
.problemBox{
  float: right;
  width: 50px;
  .el-button--text{
    font-size: 30px;
    color: black;
    margin-top: 15px;
  }
}
.el-table_1_column_1{
  color: #5a63a3;
  cursor: pointer;
}
.el-table__header{
  .el-table_1_column_1{
    color: #909399;
  }
}
.el-dialog__title{
  font-weight: bold;
}
</style>
